import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, Heart, MessageCircle, User } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { whatsappLink } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MobileBottomNav() {
    const loc = useLocation();
    const { settings } = useSettings();
    const { user } = useAuth();
    const active = (p) => loc.pathname === p;
    const item = "flex flex-col items-center gap-1 text-[10px] tracking-[0.18em] font-medium py-1";
    return (
        <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-[color:var(--pearl)] border-t border-[color:var(--soft-border)] grid grid-cols-5 py-2" data-testid="mobile-bottom-nav">
            <Link to="/" className={`${item} ${active("/") ? "text-[color:var(--champagne)]" : "text-[color:var(--charcoal)]"}`} data-testid="mnav-home"><Home size={18} /> HOME</Link>
            <Link to="/products" className={`${item} text-[color:var(--charcoal)]`} data-testid="mnav-search"><Search size={18} /> SHOP</Link>
            <Link to="/wishlist" className={`${item} text-[color:var(--charcoal)]`} data-testid="mnav-wishlist"><Heart size={18} /> WISH</Link>
            <a href={whatsappLink(settings.whatsapp_number, "Hello Singh Jewellers, I have a query.")} target="_blank" rel="noreferrer" className={`${item} text-[color:var(--whatsapp)]`} data-testid="mnav-whatsapp"><MessageCircle size={18} /> CHAT</a>
            <Link to={user ? (user.role === "admin" ? "/admin" : "/account") : "/login"} className={`${item} text-[color:var(--charcoal)]`} data-testid="mnav-account"><User size={18} /> {user ? "ME" : "LOGIN"}</Link>
        </nav>
    );
}
